import apiSlice from "./api/api";
import { EMPLOYEE, EXPORT_EMPLOYEES, GET_EMPLOYEES, LOANS, SEARCH_EMPLOYEES } from "./ENDPOINTS";

const employeeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get employee details
    getEmployee: builder.query({
        query: (id) => ({
        url: `${EMPLOYEE}/${id}`,
        method: "GET",
        }),
        providesTags: ["Employee"],
    }),
    // search employees
    searchEmployees: builder.query({
      query: ({ q, branch_id }) => {
        const params = new URLSearchParams({ q: q ?? "" });
        if (branch_id) params.append("branch_id", branch_id);
        return {
          url: `${SEARCH_EMPLOYEES}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Employee"],
    }),
    // fetch employees
    getEmployees: builder.mutation({
      query: ({filter, page, limit}) => ({
        url: `${GET_EMPLOYEES}?page=${page}&limit=${limit}`,
        method: "POST",
        body: filter
      }),
      invalidatesTags: ["Employees"],
    }),
    // save employee info
    saveEmployees: builder.mutation({
      query: (data) => ({
        url: `${EMPLOYEE}/create`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Employees"],
    }),
    updateEmployee: builder.mutation({
      query: ({data, id}) => ({
        url: `${EMPLOYEE}/${id}/update`,
        method: "PUT",
        body: data
      }),
      invalidatesTags: ["Employee"],
    }),
    // save education info
    saveEducation: builder.mutation({
      query: ({data, id}) => ({
        url: `${EMPLOYEE}/${id}/education`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Employee"],
    }),
    // save work history info
    saveWorkHistory: builder.mutation({
      query: ({data, id}) => ({
        url: `${EMPLOYEE}/${id}/work-history`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Employee"],
    }),
    // save next of kin
    saveNextOfKin: builder.mutation({
      query: ({data, id}) => ({
        url: `${EMPLOYEE}/${id}/next-of-kin`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Employee"],
    }),
    // save parents
    saveParents: builder.mutation({
      query: ({data, id}) => ({
        url: `${EMPLOYEE}/${id}/family-info`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Employee"],
    }),
    // save dependants info
    saveDependants: builder.mutation({
      query: ({data, id}) => ({
        url: `${EMPLOYEE}/${id}/dependants`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Employee"],
    }),
    // save place of worship
    savePlaceOfWorship: builder.mutation({
      query: ({data, id}) => ({
        url: `${EMPLOYEE}/${id}/place-of-worship`,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Employee"],
    }),
    // get loans
    getLoans: builder.query({
      query: ({page, search}) => ({
        url: `${LOANS}/list?page=${page}&q=${search}`,
        method: "GET",
      }),
      providesTags: ["Loans"],
    }),
    // save loans
    saveLoans: builder.mutation({
      query: (data) => ({
        url: LOANS,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Loans", "MyLoans"],
    }),
    // get guarantor requests
    getGuarantorRequests: builder.query({
      query: ({page, limit}) => ({
        url: `${LOANS}/guarantor-requests?page=${page}&limit=${limit}`,
        method: "GET",
      }),
      providesTags: ["Loans"],
    }),
    //export employee
    exportEmployees: builder.query({
      query: ({page, search}) => ({
        url: `${EXPORT_EMPLOYEES}`,
        method: "GET",
      }),
      providesTags: ["Employees"],
    }),
    // get next employee code
    getNextEmployeeCode: builder.query({
      query: () => ({
        url: `${EMPLOYEE}/next-employee-code`,
        method: "GET",
      }),
    }),
    // validate ZkTeco employee code
    validateZkTecoCode: builder.query({
      query: (code) => ({
        url: `${EMPLOYEE}/zkteco/validate-code/${code}`,
        method: "GET",
      }),
    }),
  })
});

export const {
    useLazyGetLoansQuery,
    useSaveLoansMutation,
    useLazyGetGuarantorRequestsQuery,
    useSaveDependantsMutation,
    useSaveEducationMutation,
    useSaveNextOfKinMutation,
    useSaveParentsMutation,
    useSavePlaceOfWorshipMutation,
    useSaveWorkHistoryMutation,
    useGetEmployeesMutation,
    useLazySearchEmployeesQuery,
    useSaveEmployeesMutation,
    useUpdateEmployeeMutation,
    useGetEmployeeQuery,
    useLazyExportEmployeesQuery,
    useLazyGetNextEmployeeCodeQuery,
    useLazyValidateZkTecoCodeQuery
  } = employeeApiSlice;